import React, { useState, useEffect } from "react";
import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useRequest } from "../../hooks/useRequest/useRequest";
import { REQUEST_STATUS } from "../../hooks/useRequest/useRequest.constants";
import toast from "react-hot-toast";
import { useForm } from "react-hook-form";
import PhoneInput from "../PhoneInput/PhoneInput";

const FormMap = () => {
  const { t } = useTranslation();
  const [aloqaClient, aloqaData, aloqaStatus] = useRequest();

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm();

  const submitAloqa = (data: any) => {
    let newData = {
      ...data,
      type: "contact",
    };
    console.log(newData);
    aloqaClient.post("appeal", newData);
  };

  useEffect(() => {
    if (aloqaStatus === REQUEST_STATUS.success) {
      toast.success("Muvoffaqqiyali yuborildi");
      reset();
      setValue("phoneNumber", "");
    }
  }, [aloqaStatus]);

  return (
    <div className="form_map">
      <div className="map_content">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m13!1m8!1m3!1d6071.142734619344!2d71.030235!3d40.462623!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zNDDCsDI3JzQ1LjQiTiA3McKwMDEnNDguOSJF!5e0!3m2!1sru!2s!4v1677148390176!5m2!1sru!2s"
          allowFullScreen={true}
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          className="my_map"
        ></iframe>
      </div>
      <div className="form_content">
        <form className="my_form" onSubmit={handleSubmit(submitAloqa)}>
          <div className="my_form_header">
            <h2
              className={
                localStorage.getItem("i18nextLng") === "ru"
                  ? "title_next_form active"
                  : "title_next_form"
              }
            >
              {t("FORMPAGE.TITLE")}
            </h2>
          </div>

          <div className="form_input_box">
            <p className="name">
              <label htmlFor="ism">{t("FORMPAGE.NAME")}</label>
              <input
                {...register("name", {
                  required: true,
                })}
                type="text"
                placeholder={t("FORMPAGE.placeholder.name")!}
                id="ism"
              />
              {errors.name && (
                <span className="error_input">{t("FORMPAGE.ERRORTEXT")}</span>
              )}
            </p>

            <p className="number">
              <label htmlFor="tel">{t("FORMPAGE.PHONE_NUMBER")}</label>
              <PhoneInput
                className="form_phone_input"
                placeholder={t("FORMPAGE.placeholder.phone")!}
                // name="phoneNumber"
                params={{
                  ...register("phoneNumber", {
                    required: true,
                  }),
                }}
              />
              {errors.phoneNumber && (
                <span className="error_input">{t("FORMPAGE.ERRORTEXT")}</span>
              )}
            </p>

            <p className="izoh">
              <label htmlFor="izoh">{t("FORMPAGE.EXPLANATION")}</label>
              <textarea
                placeholder={t("FORMPAGE.placeholder.text")!}
                {...register("comment", {
                  required: true,
                })}
                id="izoh"
                className="izohInput"
              ></textarea>
              {errors.comment && (
                <span className="error_input">{t("FORMPAGE.ERRORTEXT")}</span>
              )}
            </p>
          </div>

          <Button className="my_btn" type="submit">
            {t("FORMPAGE.SEND")}
          </Button>
        </form>
      </div>
    </div>
  );
};

export default FormMap;
